//import { resources } from '@/utils/constants'

export default {
    data() {
        return {
            name: 'benjamin',
            user: {
                name: 'Kenneth Kwesiga'
            }
        }
    },
    created() {
    },
    watch: {

    },
    updated() {
        
    },
    computed: {},
    methods: {

        read(resource, msg) {
            return new Promise((resolve, _) => {
                this.$historyRequest.get(`${resource}`)
                    .then(res => {
                        resolve(res);
                        //this.loadSpinner = false;
                        if (msg) {
                            console.log('>>>>>>>>>>>>>>>>>', msg, _)
                            //this.$toaster.success(`Successfully created ${msg}`)
                        }

                    })
                    .catch(err => {
                        console.log('>>>>>>>>>>>>>>>>>', err)
                        //let errorMessage = this.getErrorMessage(err)
                        //this.loadSpinner = false;
                        //this.$toaster.success('Sorry ' + errorMessage);
                    });
            });
        },

        create(resource, payload) {
            return new Promise((resolve, _) => {
                this.$historyRequest.post(`${resource}`, payload)
                    .then(res => {
                        resolve(res);
                        //return res
                        //this.loadSpinner = false;
                        //this.$toaster.success(`Successfully created ${msg}`)
                    }).catch(err => {
                        console.error(err)
                        //let errorMessage = this.getErrorMessage(err)
                        //this.loadSpinner = false;
                        //this.$toaster.success('Sorry ' + errorMessage);
                    });
            });
        },
        
    }
}
